import React from "react";
import Button from "carbon-react/lib/components/button";
import Loader from "carbon-react/lib/components/loader";

import "./DataLoadHeader.css";

const DataLoadHeader = ({
  onLoad,
  appearBusy = false,
  loadButtonCaption = "Load/refresh data",
}) => {
  const onLoadClicked = () => {
    if (onLoad && typeof onLoad === "function") onLoad();
  };

  return (
    <>
      <div className="data-load-header-container">
        <span className="data-load-header-caption"></span>
        <Button
          className="data-load-header-button"
          disabled={appearBusy}
          buttonType="primary"
          size="small"
          onClick={onLoadClicked}
        >
          {appearBusy ? (
            <Loader isInsideButton size="small" />
          ) : (
            loadButtonCaption
          )}
        </Button>
      </div>
    </>
  );
};

export default DataLoadHeader;
